const actions = {
    RECONCILIATION_CREATE_REQUEST: 'RECONCILIATION_CREATE_REQUEST',
    RECONCILIATION_CREATE_SUCCESS: 'RECONCILIATION_CREATE_SUCCESS',
    RECONCILIATION_CREATE_ERROR: 'RECONCILIATION_CREATE_ERROR',
    RECONCILIATION_READ_LIST_REQUEST: 'RECONCILIATION_READ_LIST_REQUEST',
    RECONCILIATION_READ_LIST_SUCCESS: 'RECONCILIATION_READ_LIST_SUCCESS',
    RECONCILIATION_READ_LIST_ERROR: 'RECONCILIATION_READ_LIST_ERROR',
    RECONCILIATION_READ_REQUEST: 'RECONCILIATION_READ_REQUEST',
    RECONCILIATION_READ_SUCCESS: 'RECONCILIATION_READ_SUCCESS',
    RECONCILIATION_READ_ERROR: 'RECONCILIATION_READ_ERROR',
    RECONCILIATION_UPDATE_REQUEST: 'RECONCILIATION_UPDATE_REQUEST',
    RECONCILIATION_UPDATE_SUCCESS: 'RECONCILIATION_UPDATE_SUCCESS',
    RECONCILIATION_UPDATE_ERROR: 'RECONCILIATION_UPDATE_ERROR',
    RECONCILIATION_DELETE_REQUEST: 'RECONCILIATION_DELETE_REQUEST',
    RECONCILIATION_DELETE_SUCCESS: 'RECONCILIATION_DELETE_SUCCESS',
    RECONCILIATION_DELETE_ERROR: 'RECONCILIATION_DELETE_ERROR',
    RECONCILIATION_CREATE_TRANSACTION_REQUEST: 'RECONCILIATION_CREATE_TRANSACTION_REQUEST',
    RECONCILIATION_CREATE_TRANSACTION_SUCCESS: 'RECONCILIATION_CREATE_TRANSACTION_SUCCESS',
    RECONCILIATION_CREATE_TRANSACTION_ERROR: 'RECONCILIATION_CREATE_TRANSACTION_ERROR',
    RECONCILIATION_ADD_LEDGER: 'RECONCILIATION_ADD_LEDGER',
    RECONCILIATION_SET_LEDGER: 'RECONCILIATION_SET_LEDGER',
    // RECONCILIATION_READ_TRANSACTIONS_REQUEST: 'RECONCILIATION_READ_TRANSACTIONS_REQUEST',
    // RECONCILIATION_READ_TRANSACTIONS_SUCCESS: 'RECONCILIATION_READ_TRANSACTIONS_SUCCESS',
    // RECONCILIATION_READ_TRANSACTIONS_ERROR: 'RECONCILIATION_READ_TRANSACTIONS_ERROR',
    RECONCILIATION_SET: 'RECONCILIATION_SET',
    RECONCILIATION_SET_MODE: 'RECONCILIATION_SET_MODE',
    RECONCILIATION_SET_ID: 'RECONCILIATION_SET_ID',
    RECONCILIATION_SET_DATE: 'RECONCILIATION_SET_DATE',
    RECONCILIATION_SET_CLOSING_BALANCE: 'RECONCILIATION_SET_CLOSING_BALANCE',
    RECONCILIATION_SET_RECONCILED_BALANCE: 'RECONCILIATION_SET_RECONCILED_BALANCE',
    RECONCILIATION_SET_SELECTED_ROW_KEYS: 'RECONCILIATION_SET_SELECTED_ROW_KEYS',
    RECONCILIATION_SET_SELECTED_ROWS: 'RECONCILIATION_SET_SELECTED_ROWS',
    RECONCILIATION_SET_ACTIVE_TAB_KEY: 'RECONCILIATION_SET_ACTIVE_TAB_KEY',
    RECONCILIATION_ADD_STATEMENT_LINE: 'RECONCILIATION_ADD_STATEMENT_LINE',
    RECONCILIATION_SET_STATEMENT_LINES: 'RECONCILIATION_SET_STATEMENT_LINES',
    RECONCILIATION_SET_STATEMENT_LINE: 'RECONCILIATION_SET_STATEMENT_LINE',
    RECONCILIATION_SPLIT_STATEMENT_LINE: 'RECONCILIATION_SPLIT_STATEMENT_LINE',
    RECONCILIATION_MERGE_STATEMENT_LINES: 'RECONCILIATION_MERGE_STATEMENT_LINES',
    RECONCILIATION_REMOVE_STATEMENT_LINES: 'RECONCILIATION_REMOVE_STATEMENT_LINES',
    RECONCILIATION_SET_ACTIVE_STATEMENT_LINE: 'RECONCILIATION_SET_ACTIVE_STATEMENT_LINE',
    RECONCILIATION_CLEAR_UPDATED_LINES: 'RECONCILIATION_CLEAR_UPDATED_LINES',
    RECONCILIATION_RESET: 'RECONCILIATION_RESET',
    RECONCILIATION_SET_FILTER_STATE: 'RECONCILIATION_SET_FILTER_STATE', // Manual Recon

    createReconciliation: request => ({
        type: actions.RECONCILIATION_CREATE_REQUEST,
        request,
    }),
    readReconciliationList: request => ({
        type: actions.RECONCILIATION_READ_LIST_REQUEST,
        request,
    }),
    readReconciliation: (id, request) => ({
        type: actions.RECONCILIATION_READ_REQUEST,
        id,
        request,
    }),
    updateReconciliation: (id, request) => ({
        type: actions.RECONCILIATION_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteReconciliation: id => ({
        type: actions.RECONCILIATION_DELETE_REQUEST,
        id,
    }),
    createTransaction: (txnType, request) => ({
        type: actions.RECONCILIATION_CREATE_TRANSACTION_REQUEST,
        txnType,
        request,
    }),
    addLedger: (ledger, index) => ({
        type: actions.RECONCILIATION_ADD_LEDGER,
        ledger,
        index, // Int: to be inserted in index of ledgers array
    }),
    setLedger: ledger => ({
        type: actions.RECONCILIATION_SET_LEDGER,
        ledger,
    }),
    // readTransactions: (request) => ({
    //   type: actions.RECONCILIATION_READ_TRANSACTIONS_REQUEST,
    //   request,
    // }),
    setReconciliation: reconciliation => ({
        type: actions.RECONCILIATION_SET,
        reconciliation,
    }),
    setMode: mode => ({
        type: actions.RECONCILIATION_SET_MODE,
        mode,
    }),
    setId: id => ({
        type: actions.RECONCILIATION_SET_ID,
        id,
    }),
    setDate: date => ({
        type: actions.RECONCILIATION_SET_DATE,
        date,
    }),
    setClosingBalance: closingBalance => ({
        type: actions.RECONCILIATION_SET_CLOSING_BALANCE,
        closingBalance,
    }),
    setReconciledBalance: reconciledBalance => ({
        type: actions.RECONCILIATION_SET_RECONCILED_BALANCE,
        reconciledBalance,
    }),
    setSelectedRowKeys: selectedRowKeys => ({
        type: actions.RECONCILIATION_SET_SELECTED_ROW_KEYS,
        selectedRowKeys,
    }),
    setSelectedRows: selectedRows => ({
        type: actions.RECONCILIATION_SET_SELECTED_ROWS,
        selectedRows,
    }),
    setActiveTabKey: activeTabKey => ({
        type: actions.RECONCILIATION_SET_ACTIVE_TAB_KEY,
        activeTabKey,
    }),
    addStatementLine: statementLine => ({
        type: actions.RECONCILIATION_ADD_STATEMENT_LINE,
        statementLine,
    }),
    setStatementLine: statementLine => ({
        type: actions.RECONCILIATION_SET_STATEMENT_LINE,
        statementLine,
    }),
    setStatementLines: statementLines => ({
        type: actions.RECONCILIATION_SET_STATEMENT_LINES,
        statementLines,
    }),
    splitStatementLine: (statementLine, amounts) => ({
        type: actions.RECONCILIATION_SPLIT_STATEMENT_LINE,
        statementLine,
        amounts,
    }),
    mergeStatementLines: (lines, description) => ({
        type: actions.RECONCILIATION_MERGE_STATEMENT_LINES,
        lines,
        description,
    }),
    removeStatementLines: lines => ({
        type: actions.RECONCILIATION_REMOVE_STATEMENT_LINES,
        lines,
    }),
    setActiveStatementLine: (line, lineType = 'match') => ({
        type: actions.RECONCILIATION_SET_ACTIVE_STATEMENT_LINE,
        line,
        lineType,
    }),
    clearUpdatedLines: () => ({ //?
        type: actions.RECONCILIATION_CLEAR_UPDATED_LINES,
    }),
    resetReconciliation: () => ({
        type: actions.RECONCILIATION_RESET,
    }),

    setFilterState: filterState => ({
        type: actions.RECONCILIATION_SET_FILTER_STATE,
        filterState,
    }),
};
export default actions;
